import axios from "axios";

export default axios.create({
  baseURL: "https://devextremereactmenu.azurewebsites.net/OdataService1.svc",
  headers: {
    "Content-Type": "application/json",
    Auth:
      "zJj1ksOT443ZZIu/pm78cyoQEnQ+CwHKCHtlW6cXy5eYhcoljmZS/0uofnWi0we8TJFLy3MZBQpLL4LE5HCsm0O26DNYznWsNslXRhQMtycBUWZiXcaPhRxkUEPziaIHlxhsyw=="
  }
});
